function AuthScene() {
  return (
    <div className="auth-scene" aria-hidden="true">
      <div className="auth-scene__base" />
      <div className="auth-scene__blob auth-scene__blob--1" />
      <div className="auth-scene__blob auth-scene__blob--2" />
      <svg
        className="auth-scene__waves"
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-100 620 C240 420 480 500 760 420 S1220 340 1540 380"
          fill="none"
          stroke="rgba(127, 148, 173, 0.22)"
          strokeWidth="1.15"
        />
        <path
          d="M-80 180 C300 40 560 140 880 80 S1280 20 1520 70"
          fill="none"
          stroke="rgba(148, 163, 184, 0.38)"
          strokeWidth="1"
        />
        <path
          d="M80 760 Q420 640 880 720 T1420 660"
          fill="none"
          stroke="rgba(107, 130, 153, 0.16)"
          strokeWidth="0.95"
        />
        <path
          d="M200 480 C520 360 900 440 1200 400"
          fill="none"
          stroke="rgba(203, 213, 225, 0.35)"
          strokeWidth="0.85"
        />
      </svg>
    </div>
  );
}

export default AuthScene;
